import {FC, useMemo} from 'react'
import {ID} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/UsersListViewProvider'

type Props = {
  id_medium: ID
}

const MediumSelectionCell: FC<Props> = ({id_medium}) => {
  const {selected, onSelect} = useListView()
  const isSelected = useMemo(() => selected.includes(id_medium), [id_medium, selected])
  return (
    <div className='form-check form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        type='checkbox'
        data-kt-check={isSelected}
        data-kt-check-target='#kt_table_users .form-check-input'
        checked={isSelected}
        onChange={() => onSelect(id_medium)}
      />
    </div>
  )
}

export {MediumSelectionCell}
